import React, { useMemo } from "react";
import { ArrowUpRight, Star } from "lucide-react";
import { DELIVERIES, PARTNERS, GOOGLE_REVIEWS_URL, TIKTOK_URL } from "../mock";

export default function Deliveries() {
  const partners = useMemo(
    () => PARTNERS.filter((p) => p.toLowerCase() !== "autoscout24"),
    []
  );
  return (
    <section className="cm-reveal py-20 lg:py-28">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="mb-10 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="label-mono mb-5 flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
              </span>
              Auto vere. Persone vere.
            </p>
            <h2 className="h-display text-[clamp(2rem,4.2vw,3.4rem)]">
              Consegne Carmaps.
            </h2>
          </div>
          <div className="flex flex-col gap-2 self-start sm:items-end sm:self-end">
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 self-start rounded-full border border-[var(--cm-line)] px-5 py-3 text-[0.88rem] font-medium transition-all duration-200 hover:border-[var(--cm-ink)] sm:self-end"
            >
              <Star size={15} className="fill-[var(--cm-green)] text-[var(--cm-green)]" />
              +50 recensioni reali su Google · Leggi
              <ArrowUpRight size={15} />
            </a>
            <p className="text-[0.85rem] text-[#7a7a72] sm:text-right">
              Guarda tutte le foto e recensioni dei nostri clienti.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {DELIVERIES.map((src, i) => (
            <div
              key={src}
              className="group aspect-[4/3] overflow-hidden rounded-[16px] border border-[var(--cm-line)]"
            >
              <img
                src={src}
                alt={`Consegna ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-3">
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="tiktok-live-chip"
            className="inline-flex items-center gap-2 rounded-full bg-[var(--cm-ink)] px-4 py-2 text-[0.82rem] font-medium text-white transition-transform duration-200 hover:scale-[1.03]"
          >
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" />
            </span>
            Seguici Live su TikTok
          </a>
          {partners.map((p) => (
            <span
              key={p}
              className="rounded-full border border-[var(--cm-line)] px-4 py-2 text-[0.82rem] text-[#5b5b54] transition-colors duration-200 hover:border-[var(--cm-ink)] hover:text-[var(--cm-ink)]"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
